module.exports = __webpack_public_path__ + "media/images/locations/sm/germany-135a26cf2ea38d604ec8cc7e4378bc67.jpg";